


















import { computed, defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: {
    angle: {
      type: String,
      default: ""
    },
    top: {
      type: String,
      default: undefined
    },
    right: {
      type: String,
      default: undefined
    },
    bottom: {
      type: String,
      default: undefined
    },
    left: {
      type: String,
      default: undefined
    },
    width: {
      type: String,
      default: ""
    },
    background: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const borderColor = computed(() => {
      let color;
      switch (props.background) {
        case "black":
          color = "#4e4e4e";
          break;
        case "white":
          color = "#fff";
          break;
        default:
          break;
      }
      return color;
    });
    const styles = computed(() => {
      const style = {
        top: props.top,
        right: props.right,
        bottom: props.bottom,
        left: props.left,
        width: props.width,
        "--border-color": borderColor.value
      };
      return style;
    });
    return { borderColor, styles };
  }
});
